import script from "./SqlExecution.vue?vue&type=script&setup=true&lang=js"
export * from "./SqlExecution.vue?vue&type=script&setup=true&lang=js"

import "./SqlExecution.vue?vue&type=style&index=0&id=1a84235d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a84235d"]])

export default __exports__